<div class="progress-bar-container" [ngStyle]="{'width': width != undefined ? width + 'px' : '100%'}">
  <div class="text-container" [ngStyle]="{'width': width != undefined ? width  + 'px' : '100%'}">

    <div class="start-text fw-bold fs-6 opacity-75" #tooltip="matTooltip" matTooltip="{{startTooltipText}}" matTooltipHideDelay="500"  [style.color]="startTextColor" *ngIf="showStartText">{{ startText }}</div>
    
    <div class="end-text fw-bold fs-6 opacity-75" #tooltip="matTooltip" matTooltip="{{endTooltipText}}" matTooltipHideDelay="500" [style.color]="endTextColor" *ngIf="showEndText">{{ endText }}</div>

  </div>
  <div class="progress-bar" [ngStyle]="{'width': width != undefined ? width + 'px' : '100%'}" [style.height.px]="height" [style.backgroundColor]="progressBarBackgroundColor">
   
    <div class="fill" [style.width.%]="progress" [style.backgroundColor]="progressBarColor" #tooltip="matTooltip" matTooltip="{{progressBarFillTooltipText}}" matTooltipHideDelay="500"></div>
    
    <div class="indicator" [style.left.%]="indicator" [style.backgroundColor]="indicatorColor" #tooltip="matTooltip" matTooltip="{{indicatorText}}" matTooltipHideDelay="500"></div>
    
    <div class="percentage" [style.color]="percentageColor">{{ progress }}%</div>
  </div>
</div>

